import { Box, Button, List, ListItem, Typography } from "@mui/joy";
import { FormattedMessage } from "react-intl";
import { AppModal } from "@/components/modals/AppModal/AppModal";
import { useState } from "react";
import { useIntl } from "react-intl";

const feedbackList = [
  { id: "question1", defaultMessage: "Что Вам нравится в занятиях?" },
  { id: "question2", defaultMessage: "Какие преподаватели особенно вдохновляют?" },
  { id: "question3", defaultMessage: "Насколько комфортно и уютно в школе?" },
  { id: "question4", defaultMessage: "Какие изменения Вы почувствовали после занятий?" },
  { id: "question5", defaultMessage: "Что бы Вы посоветовали тем, кто только думает начать?" },
];

const invitationRewards = [
  { id: "rewardIntro", defaultMessage: "Когда подруга покупает первый абонемент, вы получаете:" },
  { id: "reward1", defaultMessage: "✨ 1–2 подруги — по 25 AMANI бонусов за каждую" },
  { id: "reward2", defaultMessage: "✨ 3–4 подруги — по 50 AMANI бонусов за каждую" },
  { id: "reward3", defaultMessage: "✨ 5-я подруга — 100 AMANI бонусов" },
];

export const SocialActions = () => {
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [openInvitingModal, setOpenInvitingModal] = useState(false);
  const intl = useIntl();

  const openLink = (url: string) => {
    window.open(url, "_blank", "noopener, noreferrer");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", paddingBottom: "40px" }}>
      <Button variant="outlined" onClick={() => setOpenInvitingModal(true)}>
        <FormattedMessage defaultMessage="Пригласить подругу" />
      </Button>

      <Button variant="outlined" onClick={() => setOpenFeedbackModal(true)}>
        <FormattedMessage defaultMessage="Оставить отзыв" />
      </Button>

      <AppModal open={openInvitingModal} onClose={() => setOpenInvitingModal(false)}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Typography sx={{ fontWeight: 700 }}>
            <FormattedMessage defaultMessage="Подарок за приглашение 💃💘" />
          </Typography>

          <Box>
            <Typography>
              <FormattedMessage defaultMessage="Занятия в AMANI — это радость, энергия и уверенность." />
            </Typography>

            <Typography>
              <FormattedMessage defaultMessage="Поделитесь этим с подругой — и получите бонусы 🎁" />
            </Typography>
          </Box>

          <Box>
            {invitationRewards.map((msg) => (
              <Typography key={msg.id}>
                <FormattedMessage {...msg} />
              </Typography>
            ))}
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700 }}>
              <FormattedMessage defaultMessage="💫 Важно:" />
            </Typography>
            <Typography sx={{ display: 'inline' }}>
              <FormattedMessage defaultMessage="• подруг можно приводить" />
              <b> <FormattedMessage defaultMessage="в любое время" /></b>
            </Typography>
            <Typography>
              <FormattedMessage defaultMessage="• уровень повышается автоматически" />
            </Typography>
            <Typography sx={{ fontWeight: 700 }}>
              <FormattedMessage defaultMessage="• каждая подруга получает 25 бонусов" />
            </Typography>
          </Box>

          <Typography sx={{ fontWeight: 700 }}>
            <FormattedMessage defaultMessage="Тренироваться вместе - вдвойне приятнее!" />
          </Typography>

          <Button sx={{ width: "calc(100% - 31px)" }} onClick={() => setOpenInvitingModal(false)}>
            <FormattedMessage defaultMessage="Хорошо 💜" />
          </Button>
        </Box>
      </AppModal>

      <AppModal open={openFeedbackModal} onClose={() => setOpenFeedbackModal(false)}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Typography sx={{ fontWeight: "700" }}>
            <FormattedMessage defaultMessage="Спасибо за Вашу поддержку 🙏" />
          </Typography>

          <Typography>
            <FormattedMessage defaultMessage="Отзывы помогают другим девушкам найти AMANI, а нам — становиться ещё лучше." />
          </Typography>

          <Typography>
            <FormattedMessage defaultMessage="📝 Оставьте отзыв на Яндекс или Google картах — и получите 10 BYN на баланс в благодарность от администратора." />
          </Typography>

          <Box>
            <Typography>
              <FormattedMessage defaultMessage="Вот несколько вопросов, которые могут помочь:" />
            </Typography>

            <List sx={{ padding: 0 }}>
              {feedbackList.map((msg) => (
                <ListItem
                  key={msg.id}
                  sx={{
                    padding: 0,
                    margin: 0,
                    minHeight: 0,
                    "&::before": {
                      content: '"–"',
                      marginRight: "8px",
                    },
                  }}
                >
                  {intl.formatMessage(msg)}
                </ListItem>
              ))}
            </List>
          </Box>

          <Button
            sx={{ width: "calc(100% - 31px)" }}
            onClick={() => openLink("https://telegra.ph/Set-shkol-tanca-i-plastiki-AMANI-02-17")}
          >
            <FormattedMessage defaultMessage="Оставить отзыв ✍️" />
          </Button>
        </Box>
      </AppModal>
    </Box>
  );
};
